import type { ConsentCategory } from './types';

/**
 * Default dividend rate for Series A Preferred.
 * In production, always read from shareClasses.dividendRate in Firestore.
 * This constant is a fallback and for test fixtures only.
 */
export const DEFAULT_DIVIDEND_RATE = 0.11;
export const COMPOUNDING_FREQUENCY = 'annual' as const;

export const IR_COLLECTIONS = {
  INVESTORS: 'investors',
  SHARE_CLASSES: 'shareClasses',
  HOLDINGS: 'holdings',
  INVESTOR_DOCUMENTS: 'investorDocuments',
  INVESTOR_UPDATES: 'investorUpdates',
  CONSENT_REQUESTS: 'consentRequests',
  // Subcollections
  FUNDING_EVENTS: 'fundingEvents',
  CONSENT_VOTES: 'consentVotes',
  INVESTOR_AUDIT_LOG: 'investorAuditLog',
} as const;

export const CONSENT_CATEGORIES: ReadonlyArray<{ readonly code: ConsentCategory; readonly label: string }> = [
  { code: '6a', label: 'Merger, consolidation, or business combination' },
  { code: '6b', label: 'Sale of all/substantially all assets or equity acquisition' },
  { code: '6c', label: 'Reorganization or bankruptcy petition' },
  { code: '6d', label: 'Voluntary dissolution' },
  { code: '6e', label: 'Initial Public Offering' },
  { code: '6f', label: 'Modification of bylaws/articles affecting preferred rights' },
  { code: '6g', label: 'Creation of non-wholly-owned or different-purpose subsidiaries' },
  { code: '6h', label: 'Reincorporation or reconstitution' },
  { code: '6i', label: 'Name change' },
  { code: '6j', label: 'Issuance of dilutive equity (excluding Section 701 EIP awards)' },
  { code: '6k', label: 'Redemption of 10%+ equity or QSBS-impacting redemption' },
  { code: '6l', label: 'Debt above 4x TTM adjusted EBITDA' },
  { code: '6m', label: 'Significant tax elections affecting preferred holders' },
  { code: '6n', label: 'Major investments and unbudgeted capex above $1M' },
  { code: '6o', label: 'Sales of significant assets outside ordinary course' },
  { code: '6p', label: 'Significant investment loans' },
  { code: '6q', label: 'Capital expenditure above $1M' },
  { code: '6r', label: 'Initiation/settlement of legal proceedings above $250K' },
  { code: '6s', label: 'Related party transactions above $50K annualized' },
  { code: '6t', label: 'Adoption/amendment of incentive compensation plans (excluding individual 701 EIP awards)' },
  { code: '6u', label: 'CEO base compensation increases above 5%/year' },
  { code: 'other', label: 'Other (describe in consent request)' },
];
